export default [
    {
        path: '/equipment/list/:companyId?',
        component: require('@/pages/EquipmentList').default,
        props: (route) => ({
            companyId: +route.params.companyId,
        }),
        meta: {
            crumbs: [],
        }
    },
    {
        name: 'equipmentEdit',
        path: '/equipment/edit/:equipmentId',
        component: require('@/pages/EquipmentEdit').default,
        props: (route) => ({
            equipmentId: +route.params.equipmentId,
        }),
        meta: {
            back: { label: 'View Equipment: :equipmentName', to: '/equipment/view/:equipmentId' },
            security: (auth) => auth.can({
                action: 'edit',
                model: 'equipment',
                arg: +auth.to.params.equipmentId
            })
        }
    },
    {
        name: 'equipmentCreate',
        path: '/equipment/create/:companyId',
        component: require('@/pages/EquipmentCreate').default,
        props: (route) => ({
            companyId: +route.params.companyId,
        }),
        meta: {
            // NB: this should never show up (redirects to equipmentEdit)
            back: { label: 'Equipment List', to: '/equipment/list' },
            security: (auth) => auth.can({ action: 'create', model: 'equipment', arg: +auth.to.params.companyId })
        }
    },
    {
        name: 'equipmentImport',
        path: '/equipment/import/:companyId',
        component: require('@/pages/EquipmentImport').default,
        props: (route) => ({
            companyId: +route.params.companyId,
        }),
        meta: {
            back: { label: 'Equipment List', to: '/equipment/list' },
            security: (auth) => auth.can({ action: 'create', model: 'equipment', arg: +auth.to.params.companyId })
        }
    },
    {
        name: 'equipmentView',
        path: '/equipment/view/:equipmentId',
        component: require('@/pages/EquipmentView').default,
        props: (route) => ({
            equipmentId: +route.params.equipmentId,
        }),
        meta: {
            back: { label: 'Equipment List', to: '/equipment/list' },
            security: (auth) => auth.can({ action: 'view', model: 'equipment', arg: +auth.to.params.equipmentId })
        }
    },
    {
        name: 'attachmentView',
        path: '/equipment/attachment/:attachmentId',
        component: require('@/pages/AttachmentView').default,
        props: (route) => ({
            attachmentId: +route.params.attachmentId,
        }),
        meta: {
            security: (auth) => auth.can({ action: 'view', model: 'equipment', arg: +auth.to.params.equipmentId })
        }
    },
    {
        path: '/rental-equipment/list',
        component: require('@/pages/RentalEquipmentList').default,
    },
]
